import moment from 'moment';
import { Component, OnInit, ViewChild } from '@angular/core';
import {LoggingService, NotificationCommunicationService, SnackbarService} from '@tymes4-shared';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {ConfirmService} from '@tymes4-shared';
import { HttpLoaderService } from '@tymes4-shared';
import { FormGroup, FormControl } from '@angular/forms';
import { EditSeatPlanComponent } from 'app/shared/dialogs/edit-seat-plan/edit-seat-plan.component';
import { CreateSeatGridComponent } from 'app/shared/dialogs/create-seat-grid/create-seat-grid.component';
import { EditUnplacedTicketsComponent } from 'app/shared/dialogs/edit-unplaced-tickets/edit-unplaced-tickets.component';
import { CopyVBBFormComponent } from 'app/shared/dialogs/copy-vbb-form/copy-vbb-form.component';
import { EditVBBFormComponent } from 'app/shared/dialogs/edit-vbb-form/edit-vbb-form.component';
import { SectionSelectorComponent } from '../venue-definition/section-selector/section-selector.component';
import { TranslateService } from '@ngx-translate/core';
import { VenueEditChangeLogComponent } from '../../dialogs/venue-edit-change-log/venue-edit-change-log.component';
import { EntranceService, EpFilterArgs, EventPlacement, EventPlacementDetailModel, EventPlacementService, EventPlacementWithStatusView, EventService, FilterCriterionModel, FilterGroupModel, FilterGroupsService, LinkedEntranceView, LongRunningOperationTypeEnum, TicketType, TicketTypeService, VbbFilterArgs, VenueBuildingBlock, VenueBuildingBlockDetail, VenueBuildingBlockService } from '../../api';
import { Observable } from 'rxjs-compat/Observable';
import { debounceTime, filter } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { EntranceCoverageHelper } from '../../helpers/entrance-coverage-helper';
import { canAddPositionsOfType, heldTicketTypeNames, isMixedSection } from '../../helpers/section-ticket-type.helper';


@Component({
    selector: 'app-venue-placements-editor',
    templateUrl: './venue-placements-editor.component.html',
    styleUrls: ['./venue-placements-editor.component.scss'],
    standalone: false
})
export class VenuePlacementsEditorComponent implements OnInit {

  public inSingleEntranceMode: boolean = true;

  public longRunningOperationTypeEnum = LongRunningOperationTypeEnum;
  public isInArchiveMode = this.authService.isInArchiveMode();

  public selectedFilterGroup: FilterGroupModel = null;
  public allCriteria: FilterCriterionModel[] = [];
  public filterGroups: FilterGroupModel[] = []
  public selectedCriteria: FilterCriterionModel[] = [];
  public storedCriteria: FilterCriterionModel[] = [];
  public selectableCriteria: FilterCriterionModel[] = [];
  public notSelectedCriteria: FilterCriterionModel[] = [];
  public filteredCriteria: FilterCriterionModel[] = [];


  public saving: boolean = false;


  constructor(private venue: VenueBuildingBlockService,
              private notificationCommunicationService : NotificationCommunicationService,
              private eventPlacementService: EventPlacementService,
              private logging: LoggingService,
              private dialog: MatDialog,
              private confirmService: ConfirmService,
              private entrance: EntranceService,
              private loader:HttpLoaderService,
              private eventService: EventService,
              private ticketTypeService: TicketTypeService,
              private translate: TranslateService,
              private snackBar: SnackbarService,
              private authService: AuthService,
              private vbbService: VenueBuildingBlockService,
              private filterGroupsService: FilterGroupsService,
              private entranceCoverageHelper: EntranceCoverageHelper) { }

    @ViewChild('pbPendingChanges') pbPendingChanges: any;

    currentTabId = 'positions';
    editingVBBId: number = 0;
    editingVBB: any = null;
    location: any = null;
    ticketTypes: any[] = [];
    selectedTabIdx = 0;
    hasUnpublishedChanges = false;
    nrOfChangeLogs = 0;

    public tabDetails: any[] = [];

    public filteredEntrances: any[] = [];
    public vbbEntrances: any[] = [];
    private selectedEntrances: any[] = [];
    public entranceForm!: FormGroup;
    public filterForm!: FormGroup;
    private entranceSearchControl!: FormControl;
    private filterSearchControl!: FormControl;
    public event: any = null;

    eventPlacementEventId: number | null = null;
    soldTickets: number = 0;


    tabIndex = -1;

    @ViewChild('sectionSelectorComponent') sectionSelector!: SectionSelectorComponent;
    @ViewChild('ticketTabs') ticketTabGroup: any;

    ngOnInit() {

    }


    onTabChange(e: any) {
      this.currentTabId = e.selectedTab.id;
    }

    public initializeComponent(parentId: number, eventId: number | null) {

      this.editingVBBId = parentId;
      this.eventPlacementEventId = eventId;

      //loadVenueDetails
      this.sectionSelector.initialize(parentId, this.eventPlacementEventId);

      if (this.eventPlacementEventId !== null) {
        this.eventService.getEvent(this.eventPlacementEventId).subscribe((data) => {
          this.event = data;
        });
      }
      else {

        this.venue.getVenueBuildingBlockDetails(parentId).subscribe((data: VenueBuildingBlockDetail) => {
          this.location = data;
          this.nrOfChangeLogs = data.ChangeResults.length;
        });
      }

       //retrieve all tickettypes that should be editable
       this.ticketTypeService.getAllEditableInVenueDefinition().subscribe((data: TicketType[]) => {

        data.forEach(element => {
          this.tabDetails.push ({
            loading: false, endpoints: null
          });
        });

        this.ticketTypes = data;

      });

      //setup the autocomplete for entrances
      this.entranceSearchControl = new FormControl();
      this.entranceSearchControl.valueChanges.pipe(debounceTime(400)) //give the user some time to end the query
        .subscribe(data => {

          this.loader.open();

          //max 200 results sorted on name
          this.entrance.searchEntrances(data, 1, 200, 'Name').subscribe(data =>{
              this.filteredEntrances = this.removeLinkedEntrances(data.Records)
              this.loader.close();
          });

      });

      this.entranceForm = new FormGroup({
        entranceSearch: this.entranceSearchControl
      });

      this.filterGroupsService.getAllFilterGroups().subscribe((data: FilterGroupModel[]) => {
        this.filterGroups = data;
        this.allCriteria = data
        .map((filter: FilterGroupModel) => filter.Criteria)
        .reduce((acc: FilterCriterionModel[], criteria: FilterCriterionModel[]) => acc.concat(criteria), []);
        this.selectableCriteria = this.allCriteria;
      })


      //setup the autocomplete for filters
      this.filterSearchControl = new FormControl();
      this.filteredCriteria = [...this.notSelectedCriteria];
      this.filterSearchControl.valueChanges.pipe(debounceTime(400)) //give the user some time to end the query
        .subscribe(data => {
          const rgxp = new RegExp(data, "gi");
          this.filteredCriteria = this.notSelectedCriteria.filter(c => this.translate.instant(c.Code ?? '').match(rgxp))
      });

      this.filterForm = new FormGroup({
        filterSearch: this.filterSearchControl
      });


    }

    selectedTicketType: any = null;

    publish() {

      this.venue.getVbbPendingEntranceCoverage(this.editingVBBId).subscribe(coverage => {
        if (!this.entranceCoverageHelper.isCovered(coverage)) {
          return;
        }

        this.venue.getLinkedEvents(this.editingVBBId).subscribe(events => {

        this.loader.close();

        let title = this.translate.instant('LOCATIONEDIT.APPLYCHANGES.CONFIRM.TITLE');

        let msg: string;

        if (!events?.length) {
          msg = this.translate.instant('LOCATIONEDIT.APPLYCHANGES.CONFIRM.MESSAGE-NO-EVENTS');
        }
        else {
          msg = this.translate.instant('LOCATIONEDIT.APPLYCHANGES.CONFIRM.MESSAGE');

          let done = 0;
          let evList = '';

          for (let e of events) {

            done ++;

            if (done > 10) {
              let moremsg = this.translate.instant('LOCATIONEDIT.CREATESECTION.CONFIRM.MOREMESSAGE');
              moremsg = moremsg.replace('[count]', events.length - 10);
              evList += `<li>${moremsg}</li>`;
              break;
            }
            else {
              const dte = moment(e.StartDateTime);
              evList += `<li>${dte.format("DD-MM-YYYY hh:mm")} - ${e.Name}</li>`;
            }
          }

          evList = "<ul>" + evList + "</ul>";

          msg = msg.replace('[eventlist]', evList);
        }

        this.confirmService.confirm({
          title: title,
          message: msg,
          okonly: false
        },'500px').subscribe((confirmed: boolean) => {
          if (confirmed !== true) {
            return;
          }

          this.loader.open();
          this.venue.applyPendingChanges(this.editingVBBId).subscribe(lro => {
            this.notificationCommunicationService.updateNotificationsAndLROS();
            this.loader.close();
          });
        });
      });
      });
    }

    undo() {

      let title = this.translate.instant('LOCATIONEDIT.UNDOPENDING.CONFIRM.TITLE');
      let msg = this.translate.instant('LOCATIONEDIT.UNDOPENDING.CONFIRM.MESSAGE');

      this.confirmService.confirm({
        title: title,
        message: msg,
        okonly: false
      }).subscribe((confirmed: boolean) => {
        if (confirmed !== true) {
          return;
        }

        this.loader.open();
        this.venue.undoPendingChanges(this.editingVBBId).subscribe(_ => {
          this.loadVenueDetails(this.editingVBBId);
          this.loader.close();
          this.snackBar.open(this.translate.instant('GENERIC.SNACKBAR.CHANGES-UNDONE'), 'GENERIC.SNACKBAR.CLOSE');
        });
      });
    }

    selectTicketType(ticketType: any, i: number) {
      this.loadTabDetails(i);
    }

    ticketTypeIsSelected(ticketType: any) {
      if (this.selectedTicketType == null) return false;
      return (this.selectedTicketType.Id == ticketType.Id);
    }

    markSelectedAsDefault(entrance: any) {

      this.loader.open();

      const defaultObservable = this.eventPlacementEventId == null ? this.venue.setDefaultEntranceForVBB(this.editingVBB.Id, entrance.Id) : this.eventPlacementService.setDefaultEntranceForEP(this.editingVBB.Id, entrance.Id);

      defaultObservable.subscribe((data: boolean) => {
        this.loadVenueDetails(this.editingVBBId, this.selectedTabIdx);
      });
    }

    //Removes entrances that are already linked to the vbb
    removeLinkedEntrances(foundEntrances: any[]) {

      let result: any[] = [];

      for (let e of foundEntrances) {
        if (this.findInArray(e.Id) == null)   {
          result.push(e);
        }
      }

      return result;
    }

    findInArray(id: number) {
      const r = this.vbbEntrances.find(function(vbbEntrance) { return vbbEntrance.Id == id })
      return r;
    }

    onEntranceAdd(e: any) {

      this.loader.open();
      this.entranceForm.controls['entranceSearch'].setValue(''); //clear for the next add
      let entrance = e.option.value;

      //add the entrance to the list before storing.
      this.vbbEntrances.splice(0, 0, entrance);

      const saveObservable = this.eventPlacementEventId == null ? this.venue.addEntranceToVBB(this.editingVBB.Id, entrance) : this.eventPlacementService.addEntranceToEP(this.editingVBB.Id, entrance);

      //we can save now
      saveObservable.subscribe((data:any) => {
        //refresh the list
        this.loadVenueDetails(this.editingVBBId, this.selectedTabIdx);
        this.loader.close();
      });

      this.logging.log(entrance);
    }

    deleteEntrance(e: any) {

      this.confirmService.confirm({title: this.translate.instant('GENERIC.CONFIRM.CONFIRM'),
        message: this.translate.instant('GENERIC.CONFIRM.WARNING.MESSAGE.CONFIRM-DELETE')})
        .subscribe((result: boolean) => {
          if (!result) {
            return;
          }

          const idsToDelete = [e.Id];

          if (this.eventPlacementEventId != null) {
            this.eventPlacementService.getEpEntranceRemovalCoverage(this.editingVBB.Id, idsToDelete)
              .subscribe(coverage => {
                if (!this.entranceCoverageHelper.isCovered(coverage)) {
                  return;
                }
                this.deleteConfirmedEntrances(idsToDelete);
              });
            return;
          }

          this.deleteConfirmedEntrances(idsToDelete);
        });
    }

    private deleteConfirmedEntrances(idsToDelete: number[]) {
          this.loader.open();
          for (let e of this.selectedEntrances) {
            const idx = this.vbbEntrances.indexOf(e);
            this.vbbEntrances.splice(idx, 1);
          }
          const deleteObservable = this.eventPlacementEventId == null ? this.venue.deleteEntrancesFoVBB(this.editingVBB.Id, idsToDelete) : this.eventPlacementService.deleteEntrancesForEP(this.editingVBB.Id, idsToDelete);
          deleteObservable.subscribe(_ => {
            this.loadVenueDetails(this.editingVBBId, this.selectedTabIdx);
            this.loader.close();
          });
    }

    submitFilterChanges() {
      this.loader.open();
      this.saving = true;

      const isEventPlacement = this.eventPlacementEventId != null;

      const onComplete = () => {
          this.loadVenueDetails(this.editingVBBId, this.selectedTabIdx);
          this.loader.close();
          this.saving = false;
      };

      if (isEventPlacement) {
          const args: EpFilterArgs = { EventId: this.eventPlacementEventId, Criteria: this.selectedCriteria };
          this.logging.log(args);
          this.eventPlacementService.alterCriteriaForEP(this.editingVBB.Id, args).subscribe(onComplete);
      } else {
          const args: VbbFilterArgs = { VbbId: this.editingVBBId, Criteria: this.selectedCriteria };
          this.logging.log(args);
          this.vbbService.alterFiltersForSection(args).subscribe(onComplete);
      }
    }

    openSeatPlan(endpoints: any) {

      let title = `${this.translate.instant('LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.TITLE.NEW')} ${this.editingVBB.Name}`;

      let dialogRef: MatDialogRef<any> = this.dialog.open(EditSeatPlanComponent,
      {
        panelClass: 'full-width-dialog',
        disableClose: false,
        height: '95%',
        width: '98vw',
        maxWidth: '98vw',
        data: {
              title: title,
              payload:
              {
                eventPlacementEventId: this.eventPlacementEventId,
                endpoints: endpoints,
                ParentVBB: this.editingVBB
              }
            }
      });

      dialogRef.afterClosed().subscribe(data => {
        //done, refresh.
        this.loadVenueDetails (this.editingVBBId, this.selectedTabIdx);
      });
    }


    loadTabDetails(idx: number) {

      if (idx >= this.tabDetails.length) return;

      this.tabIndex = idx;
      this.selectedTicketType = this.ticketTypes[idx];
      this.loader.open();
      this.selectedTabIdx = idx;

      this.tabDetails[idx].endpoints = null; //reset

      const detailObservable : Observable<VenueBuildingBlock[] | EventPlacementWithStatusView[]> = this.eventPlacementEventId === null ?
        this.venue.getVenueBuildingBlockSeatsByTicketType(this.editingVBB.Id, this.ticketTypes[idx].Id) : this.eventPlacementService.getEventPlacementSeatsByTicketType(this.editingVBB.Id, this.ticketTypes[idx].Id);

        detailObservable.subscribe(data => {

          this.soldTickets = 0;

          if (this.isEventPlacementWithStatusArray(data)) {
            this.tabDetails[idx].allEndpoints = data;
            this.tabDetails[idx].endpoints = data.filter(ep => !ep.Blocked);
            data.forEach((ep) => {
              this.soldTickets += Number(ep.Sold ?? 0);
            });
          }
          else{
            this.tabDetails[idx].allEndpoints = null;
            this.tabDetails[idx].endpoints = data;
          }
          this.tabDetails[idx].loading = false;

          this.loadLinkedEntrances();
      });
    }

    private isEventPlacementWithStatusArray(data: VenueBuildingBlock[] | EventPlacementWithStatusView[]): data is EventPlacementWithStatusView[] {
      return data.length > 0 && 'Sold' in data[0];
    }

    openPlacedEndPointDialog(data: any = {}, isNew?) {

      let title = this.translate.instant('LOCATION.VENUE-DEFINITION.EDIT-TICKETS-DIALOG.TITLE.NEW');

      let dialogRef: MatDialogRef<any> = this.dialog.open(CreateSeatGridComponent, {
        width: '720px',
        disableClose: true,
        data: { title: title, payload: data, isNew: isNew }
      });

      dialogRef.afterClosed().subscribe(data => {
        //Done, refresh the data.
        this.loadVenueDetails(this.editingVBBId, this.selectedTabIdx)
      });

    }

    openUnplacedTicketsDialog(data: any = {}, isNew?) {

      let title = this.translate.instant('LOCATION.VENUE-DEFINITION.ADD-TICKETS-DIALOG.TITLE.NEW', {name: data.TicketTypeName});

      let dialogRef: MatDialogRef<any> = this.dialog.open(EditUnplacedTicketsComponent, {
        width: '720px',
        disableClose: true,
        data: { title: title, payload: data, isNew: isNew }
      });

      dialogRef.afterClosed().subscribe((data:any) => {
        //Done, refresh the data.
        this.loadVenueDetails(this.editingVBBId, this.selectedTabIdx)
      });
    }

  openEditDialog(parentId: number | null, data: any = {}, isNew?: boolean) {

    let title = isNew ? this.translate.instant('LOCATION.VENUE-DEFINITION.EDIT-SECTION-DIALOG.TITLE.NEW') : `${this.translate.instant('LOCATION.VENUE-DEFINITION.EDIT-SECTION-DIALOG.TITLE.EDIT')} ${data.Name}`;

    data.VenueBuildingBlockTypeId = 2;
    data.parentId = parentId;

    let dialogRef: MatDialogRef<any> = this.dialog.open(EditVBBFormComponent, {
      width: '720px',
      disableClose: true,
      data: { title: title, payload: data, isNew : isNew, eventId: this.eventPlacementEventId }
    });

    dialogRef.afterClosed().subscribe(id => {

      if (!id) {
        // If user press cancel
        this.logging.log('Dialog canceled');
        return;
      }

      this.logging.log('Object has been saved, id =' + id);

      //Reload the edited object
      this.loadVenueDetails(id);

      //Now notify the section selection that a refresh of selection is needed.
      this.sectionSelector.sectionUpdated(id);
    });
  }

    deleteVBB()
    {
      this.logging.log ('deleting ' + this.editingVBB.Name);

      this.confirmService.confirm({
        title: this.translate.instant('GENERIC.CONFIRM.CONFIRM'),
        message: this.translate.instant('LOCATION.LOCATIONS.CONFIRM.DELETE.DESCRIPTION')})
        .subscribe((result: boolean) => {
          if (!result) {
            return;
          }

          this.loader.open();
          this.venue.deleteVenueBuildingBlock(this.editingVBB.Id).subscribe((data: number) => {
            this.sectionSelector.sectionUpdated(null);
            this.loader.close();
          });
        });
    }

    onUnplacedTicketRefreshRequired($event)
    {
      this.loadVenueDetails(this.editingVBBId, this.selectedTabIdx);
    }

    onVenueBuildingBlockSelected(args: any) {

      this.editingVBBId = args.Id;

      if (args.Id < 0) {
        //the component passes a negative id when a new item should be added.
        this.openEditDialog(args.ParentId, {}, true);
      }
      else {
        //this means an item is selected
        this.loadVenueDetails(args.Id);
      }
    }

    progressFinished() {
      this.loadVenueDetails(this.editingVBBId);
    }

    loadVenueDetails(id: number, selectedTabIdx = 0) {

      this.loader.open();

      //clear the current vbb so that the user is unable to click on the buttons before the section is fully loaded
      this.editingVBB = null;
      this.editingVBBId = 0;

      //the t4-tabs header is destroyed and recreated with this card, so it always snaps back to the first tab; keep the shown content in sync
      this.currentTabId = 'positions';

      const detailObservable : Observable<VenueBuildingBlockDetail | EventPlacementDetailModel> = this.eventPlacementEventId === null
        ? this.venue.getVenueBuildingBlockDetails(id)
        : this.eventPlacementService.getEventPlacementDetails(id);

      detailObservable.subscribe((data: VenueBuildingBlockDetail | EventPlacementDetailModel) =>{

        this.editingVBB = data;
        this.editingVBBId = data.Id;
        this.hasUnpublishedChanges = (this.event === null && this.editingVBB.HasUnpublishedChanges);
        this.nrOfChangeLogs = this.eventPlacementEventId === null
          ? data["ChangeResults"].length // ugly workaround because the models do not contain List<COMPLEX_TYPES>, so that's why `data["ChangeResults"]`
          : 0;

        //the first tab is always open, so get the details
        this.loadTabDetails(selectedTabIdx);

      });


      const filterSubscription = this.eventPlacementEventId == null ? this.vbbService.findFiltersForSectionForVbb(id) : this.eventPlacementService.findFiltersForSectionForEp(id);
      filterSubscription.subscribe((data: number[]) => {
        this.updateCriteriaSelection(data);

      })
    }

    openChangeLog() {

      let title = this.translate.instant('LOCATION.LOCATIONS.HISTORYDIALOG.TITLE');

      let dialogRef: MatDialogRef<any> = this.dialog.open(VenueEditChangeLogComponent, {
        width: '1024px',
        disableClose: true,
        data: { title: title, vbbId: this.editingVBB.Id, logRecords: this.editingVBB.ChangeResults }
      });

      dialogRef.afterClosed().subscribe();

    }

    loadLinkedEntrances() {

      const detailObservable = this.eventPlacementEventId === null ? this.venue.getEntrancesForVBB(this.editingVBB.Id) : this.eventPlacementService.getEntrancesForEp(this.editingVBB.Id);

      //retrieve the entrances for the VBB
      detailObservable.subscribe((data: LinkedEntranceView[]) => {
        this.vbbEntrances = data;
        this.loader.close();
      });
    }

    copySection() {

      let title = this.translate.instant('LOCATION.LOCATIONS.COPYDIALOG.TITLE');

      let parentId = null;

      if (this.editingVBB.Parents != null && this.editingVBB.Parents.length > 1) {
        //Set the parent so that the form can display it.
        parentId = this.editingVBB.Parents[this.editingVBB.Parents.length - 2].Id;
      }


      let dialogRef: MatDialogRef<any> = this.dialog.open(CopyVBBFormComponent, {
        width: '720px',
        disableClose: true,
        data: {
            title: title,
            venueBuildingBlockTypeId: this.editingVBB.VenueBuildingBlockTypeId,
            parentId: parentId,
            selectedObjectId: this.editingVBB.Id
          }
      });

      dialogRef.afterClosed().subscribe(id => {
        if (!id) {
          // If user press cancel
          this.logging.log('Dialog canceled');
          return;
        }

        this.logging.log('Object has been saved, id =' + id);
        this.sectionSelector.sectionUpdated(this.editingVBB.Id);
      });

    }

    editDetails() {
      //Called from the actions menu of the venue.
      //At this point we have the details but not the physical object.
      //Also, refresh to make sure we have the latest version

      const detailObservable : Observable<VenueBuildingBlock | EventPlacement> = this.eventPlacementEventId === null ?  this.venue.getVenueBuildingBlock(this.editingVBB.Id) :  this.eventPlacementService.getEventPlacement(this.editingVBB.Id);

        detailObservable.subscribe((data: VenueBuildingBlock | EventPlacement) => {

        let parentId: number | null = null;

        if (this.editingVBB.Parents != null && this.editingVBB.Parents.length > 1) {
          //Set the parent so that the form can display it.
          parentId = this.editingVBB.Parents[this.editingVBB.Parents.length - 2].Id;
        }

        this.openEditDialog(parentId, data, false);

      });
    }

    addTickets(ticketType: any, idx: number, unplacedTicketList?: any) {

      let isNew: boolean = false;
      let currentDimensions: any = null;

      //set the required data
      currentDimensions = {};
      currentDimensions.SelectedIdx = idx;
      currentDimensions.ParentId = this.editingVBB.Id;
      currentDimensions.TicketTypeId = ticketType.Id;

      if (ticketType.IsPlaced == 1) {

        //when this section already contains places endpoints we need to pass the current dimensions
        if (this.tabDetails[idx].endpoints != null && this.tabDetails[idx].endpoints.length > 0) {
          //already tickets
          const data = this.tabDetails[idx].endpoints;
          currentDimensions.NrOfRows = Math.max.apply(Math, data.map((r: any) => r.Row));
          currentDimensions.NrOfColumns = Math.max.apply(Math, data.map((r: any) => r.Column));
        }
        else {
          //create defaults
          currentDimensions.NrOfColumns=10;
          currentDimensions.NrOfRows=10;
          isNew = true;
        }

        this.openPlacedEndPointDialog(currentDimensions, isNew);
      }
      else {
        //unplaced endpoints
        isNew = true;
        this.logging.log('opening unplaced tickets dialog');
        currentDimensions.TicketTypeName = this.translate.instant(ticketType.Name);
        this.openUnplacedTicketsDialog(currentDimensions, isNew);
      }
    }

    endpointsAvailable(i: number) {
      return (this.tabDetails[i] && this.tabDetails[i].endpoints != null && this.tabDetails[i].endpoints.length > 0);
    }

    canAddPositions(ticketType: TicketType): boolean {
      return canAddPositionsOfType(this.heldTicketTypeIds(), ticketType.Id);
    }

    sectionIsMixed(): boolean {
      return isMixedSection(this.heldTicketTypeIds());
    }

    sectionTicketTypeNames(): string {
      return heldTicketTypeNames(this.heldTicketTypeIds(), this.ticketTypes);
    }

    private heldTicketTypeIds(): number[] {
      return this.eventPlacementEventId === null ? this.editingVBB?.PositionTicketTypeIds ?? [] : [];
    }

    selectAllFilterGroups(){
      this.selectableCriteria = this.allCriteria;
      this.selectedFilterGroup = null;
    }
    selectFilterGroup(filterGroupId: number){
      const selectedFilterGroup = this.filterGroups.find(f => f.Id == filterGroupId);
      if(selectedFilterGroup == null){
        return;
      }
      this.selectableCriteria = selectedFilterGroup.Criteria;
      this.selectedFilterGroup = selectedFilterGroup;
    }

    clickCriterion(criterion: FilterCriterionModel){
      const existingIndex = this.selectedCriteria.findIndex(g => g.Id === criterion.Id);
      const existingIndexInNotSelected = this.notSelectedCriteria.findIndex(g => g.Id === criterion.Id);
      if (existingIndex !== -1) {
          // Remove if exists
          this.selectedCriteria.splice(existingIndex, 1);
          this.notSelectedCriteria.push(criterion);

      } else {
          // Add if doesn't exist
          this.selectedCriteria.push(criterion);
          this.notSelectedCriteria.splice(existingIndexInNotSelected, 1);
      }
      this.filteredCriteria = this.notSelectedCriteria;
    }

    clickCriterionFromList(criterion){
      this.clickCriterion(criterion)
      this.filterForm.controls['filterSearch'].setValue(''); //clear for the next add
    }

    isCriterionSelected(criterionId: number){
      return this.selectedCriteria.some(c => c.Id === criterionId);
    }
    isFilterFormDirty(){
      if (this.storedCriteria.length !== this.selectedCriteria.length) {
          return false;
      }

      const storedCriteriaIds = this.storedCriteria.map(item => item.Id).sort();
      const selectedCriteriaIds = this.selectedCriteria.map(item => item.Id).sort();

      return storedCriteriaIds.every((id, index) => id === selectedCriteriaIds[index]);
    }
    updateCriteriaSelection(data: number[]){
      this.selectedCriteria = this.allCriteria.filter(c => data.includes(c.Id));
      this.storedCriteria = this.allCriteria.filter(c => data.includes(c.Id));
      this.notSelectedCriteria = this.allCriteria.filter(
      parent => !this.selectedCriteria.some(selected => selected.Id === parent.Id));
      this.filteredCriteria = this.notSelectedCriteria;
    }
}
